export const handleOpenModalSurvey = (statusShow,order) => ({
    type: 'OPEN_MODAL_SURVEY',statusShow,order
});

export const actionChangeInputsModalSurvey = (name,value) => ({
    type:'CHANGE_INPUTS_MODAL_SURVEY',name,value
})